import { useState, useEffect } from "react";

const inputStyle = {
  width: "100%",
  background: "var(--rasp-raised)",
  border: "1px solid var(--rasp-border)",
  borderRadius: 6,
  color: "var(--rasp-fg-2)",
  fontSize: 13,
  padding: "10px 14px",
  outline: "none",
  boxSizing: "border-box",
};

export default function SettingsView({ currentUser, API }) {
  const [linkedinCookie, setLinkedinCookie] = useState("");
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetch(`${API}/users/${currentUser.id}/onboarding`, { headers: { Authorization: `Bearer ${localStorage.getItem('expertnet_token')}` } })
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (d) {
          setLinkedinCookie(d.linkedin_session_cookie || "");
        }
      })
      .catch(() => {});
  }, []);

  const handleSave = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/users/${currentUser.id}/onboarding`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem('expertnet_token')}` },
        body: JSON.stringify({
          linkedin_session_cookie: linkedinCookie,
          onboarding_complete: 1,
        }),
      });
      if (res.ok) {
        setSaved(true);
        setTimeout(() => setSaved(false), 2000);
      }
    } catch {}
    setLoading(false);
  };

  return (
    <div style={{ padding: 32, maxWidth: 600, margin: "0 auto" }}>
      <div style={{ fontSize: 20, fontWeight: 600, color: "var(--rasp-teal-light)", marginBottom: 32 }}>
        Settings
      </div>

      <div style={{
        fontSize: 11, fontWeight: 700, color: "var(--rasp-fg-3)",
        textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 16,
      }}>
        Advanced Connections
      </div>

      <div>
        <div style={{ fontSize: 12, color: "var(--rasp-fg-3)", marginBottom: 6, marginTop: 20 }}>
          LinkedIn Session Token
        </div>
        <input
          type="password"
          style={inputStyle}
          value={linkedinCookie}
          onChange={e => setLinkedinCookie(e.target.value)}
          placeholder="Paste your token here"
        />
        <span
          onClick={() => window.open("https://chrome.google.com/webstore/detail/cookie-editor/hlkenndednhfkekhgcdicdfddnkalmdm", "_blank")}
          style={{ color: "var(--rasp-teal-light)", fontSize: 12, cursor: "pointer", display: "inline-block", marginTop: 6 }}
        >
          How to find this?
        </span>
      </div>

      <div style={{ display: "flex", alignItems: "center", marginTop: 24 }}>
        <button
          onClick={handleSave}
          disabled={loading}
          style={{
            background: "var(--rasp-grad)",
            color: "#ffffff",
            border: "none",
            borderRadius: 8,
            fontSize: 13,
            fontWeight: 600,
            padding: "10px 24px",
            cursor: loading ? "not-allowed" : "pointer",
            opacity: loading ? 0.7 : 1,
            boxShadow: "var(--rasp-elev)",
          }}
        >
          Save
        </button>
        {saved && (
          <span style={{ color: "#22c55e", fontSize: 13, marginLeft: 12 }}>Saved!</span>
        )}
      </div>
    </div>
  );
}
